import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AppRoutes } from "@/routes/AppRoutes";
import { ThemeProvider } from "@/components/providers/ThemeProvider";
import { AuthProvider } from "@/features/auth/AuthContext";
import { CartProvider } from "@/features/cart/CartContext";
import { WishlistProvider } from "@/features/wishlist/WishlistContext";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

/**
 * Root composition:
 *   ThemeProvider   → light/dark class on <html>
 *     QueryClient   → TanStack Query cache
 *       Router      → client-side navigation
 *         AuthProv  → session state (needs router for navigation callbacks)
 *           Routes  → declarative route tree
 *   Toaster         → global toast surface
 */

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 60_000,
            refetchOnWindowFocus: false,
            retry: 1,
        },
    },
});

function App() {
    return (
        <ThemeProvider defaultTheme="light" storageKey="tsgo-theme">
            <QueryClientProvider client={queryClient}>
                <BrowserRouter>
                    <AuthProvider>
                        <WishlistProvider>
                            <CartProvider>
                                <AppRoutes />
                                <Toaster
                                    position="top-center"
                                    richColors
                                    closeButton
                                    toastOptions={{ classNames: { toast: "font-sans" } }}
                                />
                            </CartProvider>
                        </WishlistProvider>
                    </AuthProvider>
                </BrowserRouter>
            </QueryClientProvider>
        </ThemeProvider>
    );
}

export default App;
